import { useDisclosure, Icon, Box } from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import EmailCalculationModal from '../../email-calculation/EmailCalculationModal';
import OfferAction from './OfferAction';

interface Props {
  offerId: string;
  isDisabled?: boolean;
  isHidden?: boolean;
  isExtendedInput?: boolean;
}

const OfferMailCalculationAction: React.FC<Props> = ({
  offerId,
  isDisabled,
  isHidden,
  isExtendedInput,
}) => {
  const { t } = useTranslation();
  const { isOpen, onClose, onOpen } = useDisclosure();

  if (isHidden) return <Box bg="white" />;

  return (
    <>
      <EmailCalculationModal
        isOpen={isOpen}
        onClose={onClose}
        quoteId={offerId}
        isExtendedInput={isExtendedInput}
      />
      <OfferAction
        icon={<Icon name="GeneralActionsSendEmail" />}
        onClick={onOpen}
        isDisabled={isDisabled}
      >
        {t('SALES-CONVERSATION_OFFERS_SINGLE-OFFER_ACTIONS_SEND-CALCULATION')}
      </OfferAction>
    </>
  );
};

export default OfferMailCalculationAction;
